import {detectErrors} from "../http/common";
import {UrlParams} from "../http/url-params-serializer";
import {ParsedResponseHeaders} from "ng2-file-upload";

export type ResponseProcessor = (json: any) => Promise<string>;

export type FileUploadDisplayUpdateInfo = {
  complete?: boolean;
  uploading?: boolean;
  success?: boolean;
  response?: string;
  status?: number;
  headers?: ParsedResponseHeaders;
  progress?: number;
};

export type UploaderDialogModel = {
  url: string;
  responseProcessor?: ResponseProcessor;
  fileExtensions?: string[];
  params?: UrlParams;
  title?: string;
};

export type UploaderDialogResult = {
  responses: any[];
  errors: Error[];
  total: number;
};

export function DefaultUploadResponseProcessor(json: any): Promise<string> {
  return new Promise((resolve) => {
    if (typeof json === "object") {
      resolve(json);
      return;
    }

    if (typeof json === "number") {
      resolve({message: json});
      return;
    }

    if (typeof json === "boolean") {
      resolve({message: json});
      return;
    }

    if (typeof json === "undefined") {
      resolve({});
      return;
    }

    try {
      const result = JSON.parse(json);
      resolve(result);
    } catch (e) {
      resolve({message: json});
    }
  })
    .then(detectErrors)
    .then(obj => obj["message"] as string);
}
